@if (show$ | async) {
<atx-page-menu [showBurgerMenuOnMobile]="showBurgerMenuOnMobile$ | async">
  @for (item of items$ | async; track item) {
  <atx-anchor
    data-e2e="secondary-navigation"
    [href]="item.href"
    [routerLink]="item.routerLink"
    [queryParams]="item.queryParams"
    [newTab]="!!item.href"
    (linkClick)="onLinkClick(item)"
    linkClass="py-2 px-4"
  >
    {{ item.text }}
  </atx-anchor>
  }
</atx-page-menu>
}
